module.exports = __webpack_public_path__ + "img/quest_selector_disabled.f31d335b.png";